import Indicator from '../Indicator';
import LineMarker from '../markers/LineMarker';
import BandMarker from '../markers/BandMarker';

/** RSI indicator */
export default class RSIIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} bands - Indicator bands
	 */
	_getDefaultParams() {
		return {
			id: 'rsi',
			name: 'Relative Strength Index',
			description:
				'The Relative Strength Index is a momentum indicator which measures the strength of price changes relative to prior moves.',
			inputs: [{ name: 'period', value: 14 }],
			bands: [
				{
					labelTranslationKey: 'band.overbought',
					valHigh: 100,
					valLow: 70
				},
				{
					labelTranslationKey: 'band.oversold',
					valHigh: 30,
					valLow: 0
				}
			],
			componentSeries: [
				{ id: 'rsi' }
			]
		};
	}

	/** @return {number} 0 */
	getRangeMin() {
		return 0;
	}

	/** @return {number} 100 */
	getRangeMax() {
		return 100;
	}

	/**
	 * @return {object}
	 * @property {LineMarker} line
	 * @property {BandMarker} overbought
	 * @property {BandMarker} oversold
	 */
	_getMarkers() {
		return {
			line: new LineMarker(),
			overbought: new BandMarker(this.params.bands[0], this.panel),
			oversold: new BandMarker(this.params.bands[1], this.panel)
		};
	}

	/**
	 * Sets indicator bands by period
	 * per JIRA NXC-368
	 */
	_setBandsByPeriod() {
		const period = this.getInput('period') || 0;
		let overBought = [100, 70];
		let overSold = [30, 0];

		if (period <= 2) {
			overBought = [100, 90];
			overSold = [10, 0];
		} else if (period >= 22) {
			overBought = [100, 60];
			overSold = [40, 0];
		}

		this.markers.overbought.params.valHigh = overBought[0];
		this.markers.overbought.params.valLow = overBought[1];

		this.markers.oversold.params.valHigh = overSold[0];
		this.markers.oversold.params.valLow = overSold[1];
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this._setBandsByPeriod();
		this.markers.overbought.render(this.panel, this.params.style.overbought);
		this.markers.oversold.render(this.panel, this.params.style.oversold);
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
